// @flow
import type {Element} from 'react'
import React, {useCallback} from 'react'
import className from 'classnames'
import accessibleOnClickProps from 'utils/MiscUtils/accessibleOnClickProps'
import type {Option} from '../types'

type Props = {
  option: Option,
  isSelected: boolean,
  onSelect: Option => void,
}

function EtcSelectorOption({option, isSelected, onSelect}: Props): Element<"div"> {
  const onClick = useCallback(() => onSelect(option), [onSelect, option])

  const optionClassName = className('etc-selector-option', 'dropdown-item', {
    'etc-selector-option--selected': isSelected,
  })
  const faClassName = className('etc-selector-option__check-icon', {
    'fa-solid fa-circle-check': isSelected,
    'fa-regular fa-circle-check': !isSelected,
  })

  return (
    <div
      className={optionClassName}
      {...accessibleOnClickProps(onClick)}
      role="menuitem"
      tabIndex={0}
    >
      <i className={faClassName} />
      <span className="etc-selector-option__title">
        {option.label}
        {option.subLabel && (
          <div className="etc-selector-option__sub-title">
            {option.subLabel}
          </div>
        )}
      </span>
    </div>
  )
}

export default EtcSelectorOption
